import api from "@/lib/api";

export default {
  getAll(funnelId) {
    return api.get("/api/v1/planner/step/get-all", { params: { any: funnelId } });
  },
  selectAll(funnelId) {
    return api.get("/api/v1/planner/step/select-all", { params: { any: funnelId } });
  },
  create(funnelId) {
    return api.post("/api/v1/planner/step/create", { name: "Novo", funnelId });
  },
  updateName(id, name) {
    return api.put("/api/v1/planner/step/update", { id, name });
  },
  updateColor(id, color) {
    return api.put("/api/v1/planner/step/update-color", { id, color });
  },
  reorder(listIds) {
    return api.put("/api/v1/planner/step/order-all", { listIds });
  },
  remove(id) {
    const ids = Array.isArray(id) ? id.join(",") : id;
    return api.delete("/api/v1/planner/step/delete", { params: { ids } });
  },
};

